import React from "react";
import "./LpExp.css";
import govtAp from "./../../../vid_img/Attributes/Government Approved.png";
import efficiency from "./../../../vid_img/Attributes/Efficiency.png";
import expertise from "./../../../vid_img/Attributes/Expertise.png";
import customer from "./../../../vid_img/Attributes/24x7 Customer Support.png";
import intReach from "./../../../vid_img/Attributes/International Reach.png";
import Transparency from "./../../../vid_img/Attributes/Transparency.png";
import secure from "./../../../vid_img/Attributes/Secure Handling.png";
import trust from "./../../../vid_img/Attributes/Trusted by Clients.png";
import price from "./../../../vid_img/Attributes/Competitive Pricing.png";
import online from "./../../../vid_img/Attributes/Online Tracking.png";
import legal from "./../../../vid_img/Attributes/Legal Compliance.png";
import time from "./../../../vid_img/Attributes/Timely Delivery.png";
const LpExpMain = () => {
  const exp = [
    {
      id: 1,
      title: "Government Approved",
      img: govtAp,
    },
    {
      id: 2,
      title: "Efficiency",
      img: efficiency,
    },
    {
      id: 3,
      title: "Expertise",
      img: expertise,
    },
    {
      id: 4,
      title: "24x7 Customer Support",
      img: customer,
    },
    {
      id: 5,
      title: "International Reach",
      img: intReach,
    },
    {
      id: 6,
      title: "Transparency",
      img: Transparency,
    },
    {
      id: 7,
      title: "Secure Handling",
      img: secure,
    },
    {
      id: 8,
      title: "Trusted by Clients",
      img: trust,
    },
    {
      id: 9,
      title: "Competitive Pricing",
      img: price,
    },
    {
      id: 10,
      title: "Online Tracking",
      img: online,
    },
    {
      id: 11,
      title: "Legal Compliance",
      img: legal,
    },
    {
      id: 12,
      title: "Free Home Pickup and Timely Delivery",
      img: time,
    },
  ];

  return (
    <div className="lpExpMain-container">
      <div className="lpExpMain-content">
        <h2>16</h2>
        <h3>Years of Experience</h3>
        <p>
          Goodway Attestation is a trusted expert in document attestation and
          apostille services, known for its in-depth industry expertise,
          streamlined processes, and unwavering commitment to authenticity.
          We've assisted thousands in getting their documents verified swiftly
          and effortlessly for international recognition.
        </p>
      </div>
      <div className="lpExpMain-content" id="lpExpMain-cardsGrid">
        {exp.map((x) => (
          <div className="lpExpMain-cardContainer" key={x.id}>
            <div className="lpExpMain-cardWrapper">
              <div className="lpExpMain-cardIco">
                <img src={x.img} alt={x.title} />
              </div>
              <div className="lpExpMain-cardTxt">
                <p>{x.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LpExpMain;
